export enum AptPaymentFrequency {
    Mensile = 'Mensile',
    UnicaSoluzione = 'Unica Soluzione',
}
